<!-- MODAL HEADER-->
<div class="row modal-bar">
  <div class="col-sm-6">
    <h5 class="modal-title">{{ passedData.title }}</h5>
  </div>
  <div class="col-sm-6">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>



<div class="section-wrapper">

  <div class="form-layout">

    <div class="row mt-5">
      <div class="col-lg-12">

        
          <input #file type="file" class="form-control" id="upload-translation"
            (change)="uploadBarcodesFile(file.files)" multiple>
            <label class="form-label" for="upload-translation">
              {{'GENERIC.BUTTON.SELECT.FILE' | translate}}
            </label>
          

          @if (progress > 0 && progress < 100) {
            <span style="font-weight:bold;color:green;">
              {{progress}}%
            </span>
          }

        </div>
      </div>

    </div>
  </div>
